/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid as MuiGrid,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import { AlertLocal } from '../components';
import { errorAlert, successAlert } from '../Shared/helpers';
import StopIcon from '@material-ui/icons/Stop';
// import useCompany from '../hooks/useCompany';
import CalenderLocal from '../components/fields/CalenderLocal';
import { buildHrFormNote, parseHrFormNote } from '../common/hrFormNote';

const buildDefaultExtraInfo = (employee: any) => ({
  jobTitle: employee?.speciality || '',
  clearanceStatus: '',
  handoverTo: '',
  assetsNotes: '',
  managementNotes: '',
});

const PopupEndService = ({
  open,
  onClose,
  addAction,
  editAction,
  employees,
  company,
  theme,
  isRTL,
  words,
  onRefresh,
  row,
  isNew,
}: any) => {
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [terminationDate, setTerminationDate] = useState<Date>(new Date());
  const [terminationDesc, setTerminationDesc] = useState('');
  const [extraInfo, setExtraInfo] = useState<any>(buildDefaultExtraInfo(null));
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      if (!isNew && row) {
        const foundEmployee = (employees || []).find(
          (emp: any) => emp._id === row.employeeId,
        );
        const parsed = parseHrFormNote(row?.note);

        // Populate form for editing
        setSelectedEmployee(
          foundEmployee || {
            _id: row.employeeId,
            name: row.employeeName,
            nameAr: row.employeeNameAr,
          },
        );
        setTerminationDate(new Date(row.time));
        setTerminationDesc(parsed?.notes || row.desc || '');
        setExtraInfo({
          ...buildDefaultExtraInfo(foundEmployee),
          ...(parsed?.extra || {}),
        });
      } else {
        resetForm();
      }
    }
  }, [open, row, isNew]);

  const handleEndService = async () => {
    if (!selectedEmployee) {
      errorAlert(setAlrt, isRTL);
      return;
    }

    setSaving(true);
    try {
      const note = buildHrFormNote({
        kind: 'endService',
        notes: terminationDesc,
        extra: extraInfo,
      });

      const variables = {
        ...(isNew ? {} : { _id: row?._id }),
        time: terminationDate,
        title: isRTL ? 'انهاء خدمة موظف' : 'End Service',
        desc: terminationDesc,
        contract: {
          contractId: '',
          contractName: '',
          contractNameAr: '',
        },
        department: {
          departmentId: selectedEmployee?.departmentId || '',
          departmentName: selectedEmployee?.departmentName || '',
          departmentNameAr: selectedEmployee?.departmentNameAr || '',
          departmentColor: selectedEmployee?.departmentColor || '',
        },
        employee: {
          employeeId: selectedEmployee._id,
          employeeName: selectedEmployee.name,
          employeeNameAr: selectedEmployee.nameAr,
        },
        bonos: 0,
        overtime: 0,
        deduction: 0,
        isWorking: 0,
        isAbsent: 0,
        isShift1: 0,
        isShift2: 0,
        isVacation: false,
        note,
      };

      const mutate = isNew ? addAction : editAction;
      const mutateName = isNew ? 'createEndService' : 'updateEndService';
      const res = await mutate({ variables });

      if (res?.data?.[mutateName]?.ok) {
        successAlert(setAlrt, isRTL);
        if (onRefresh) {
          onRefresh();
        }
        onClose();
        resetForm();
      }
    } catch (error) {
      console.log(error);
      errorAlert(setAlrt, isRTL);
    }
    setSaving(false);
  };

  const resetForm = () => {
    setSelectedEmployee(null);
    setTerminationDate(new Date());
    setTerminationDesc('');
    setExtraInfo(buildDefaultExtraInfo(null));
    setAlrt({ show: false, msg: '', type: undefined });
  };

  const activeEmployees = (employees?.filter((emp: any) => !emp.disabled) ||
    []) as any[];
  const employeeOptions =
    selectedEmployee &&
    !activeEmployees.some((emp: any) => emp._id === selectedEmployee?._id)
      ? [selectedEmployee, ...activeEmployees]
      : activeEmployees;

  if (!open) return null;

  return (
    <Box
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Paper
        elevation={3}
        style={{
          padding: 30,
          maxWidth: 600,
          width: '90%',
          maxHeight: '90vh',
          overflow: 'auto',
          borderRadius: 15,
        }}
      >
        <Typography
          variant="h5"
          style={{
            color: theme?.palette?.secondary?.main,
            fontWeight: 'bold',
            marginBottom: 30,
            textAlign: 'center',
          }}
        >
          {isRTL
            ? 'نموذج انهاء الخدمات - حجب الموظف من قائمة الرواتب'
            : 'End Service Form - Remove Employee from Salary'}
        </Typography>

        <MuiGrid container spacing={3}>
          {/* Employee Selection */}
          <MuiGrid item xs={12}>
            <TextField
              select
              fullWidth
              variant="outlined"
              label={isRTL ? 'الموظف' : 'Employee'}
              value={selectedEmployee?._id || ''}
              onChange={(e: any) => {
                const employee = employeeOptions.find(
                  (emp: any) => emp._id === e.target.value,
                );
                setSelectedEmployee(employee || null);
              }}
              SelectProps={{ native: true }}
            >
              <option value="">
                {isRTL ? 'اختر الموظف' : 'Select employee'}
              </option>
              {employeeOptions.map((emp: any) => (
                <option key={emp._id} value={emp._id}>
                  {isRTL ? emp.nameAr || emp.name : emp.name || emp.nameAr}
                </option>
              ))}
            </TextField>
          </MuiGrid>

          {/* Termination Date */}
          <MuiGrid item xs={12}>
            <CalenderLocal
              label={isRTL ? 'تاريخ انهاء الخدمات' : 'Termination Date'}
              value={terminationDate}
              onChange={(date: any) => setTerminationDate(date)}
              format="dd/MM/yyyy"
              isRTL={isRTL}
            />
          </MuiGrid>

          {/* Employee Info Display */}
          {selectedEmployee && (
            <>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={isRTL ? 'رقم الهاتف' : 'Phone'}
                  value={selectedEmployee?.phone || ''}
                  disabled
                  variant="outlined"
                />
              </MuiGrid>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={isRTL ? 'تاريخ بداية العمل' : 'Start Work Date'}
                  value={
                    selectedEmployee?.startWorkDate
                      ? new Date(
                          selectedEmployee.startWorkDate,
                        ).toLocaleDateString()
                      : ''
                  }
                  disabled
                  variant="outlined"
                />
              </MuiGrid>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={isRTL ? 'الراتب الاساسي' : 'Basic Salary'}
                  value={selectedEmployee?.basicSalary?.toLocaleString() || '0'}
                  disabled
                  variant="outlined"
                />
              </MuiGrid>
              <MuiGrid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={isRTL ? 'البدلات' : 'Allowances'}
                  value={selectedEmployee?.extraSalary?.toLocaleString() || '0'}
                  disabled
                  variant="outlined"
                />
              </MuiGrid>
            </>
          )}

          {/* Description/Reason */}
          <MuiGrid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label={isRTL ? 'سبب انهاء الخدمات' : 'Termination Reason'}
              value={terminationDesc}
              onChange={(e) => setTerminationDesc(e.target.value)}
            />
          </MuiGrid>

          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'المسمى الوظيفي' : 'Job Title'}
              value={extraInfo?.jobTitle || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  jobTitle: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'حالة المخالصة' : 'Clearance Status'}
              value={extraInfo?.clearanceStatus || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  clearanceStatus: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'تسليم العهدة الى' : 'Handover To'}
              value={extraInfo?.handoverTo || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  handoverTo: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label={isRTL ? 'ملاحظات العهدة' : 'Assets Notes'}
              value={extraInfo?.assetsNotes || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  assetsNotes: e.target.value,
                }))
              }
            />
          </MuiGrid>
          <MuiGrid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              label={isRTL ? 'ملاحظات الادارة' : 'Management Notes'}
              value={extraInfo?.managementNotes || ''}
              onChange={(e) =>
                setExtraInfo((prev: any) => ({
                  ...prev,
                  managementNotes: e.target.value,
                }))
              }
            />
          </MuiGrid>

          {/* Action Buttons */}
          <MuiGrid item xs={12}>
            <Box
              display="flex"
              justifyContent="center"
              style={{ gap: 16, marginTop: 20 }}
            >
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<StopIcon />}
                onClick={handleEndService}
                disabled={!selectedEmployee || saving}
                style={{ minWidth: 180 }}
              >
                {saving
                  ? isRTL
                    ? 'جاري الحفظ...'
                    : 'Saving...'
                  : isRTL
                    ? 'انهاء الخدمات'
                    : 'End Service'}
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={onClose}
                style={{ minWidth: 120 }}
              >
                {isRTL ? 'إلغاء' : 'Cancel'}
              </Button>
            </Box>
          </MuiGrid>
        </MuiGrid>

        {alrt.show && (
          <AlertLocal
            isRTL={isRTL}
            type={alrt?.type}
            msg={alrt?.msg}
            top={-100}
          />
        )}
      </Paper>
    </Box>
  );
};

export default PopupEndService;
